<template>
    <div class="modal" tabindex="-1" ref="master">
        <div class="modal-dialog" :class="modalClass">
            <div class="modal-content">
                <div class="modal-header" v-show="!!$slots.header">
                    <slot name="header"></slot>
                    <button @click="close"
                        class="btn-close" 
                        :aria-label="$_locale('close')">
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer" v-show="!!$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// IMPORTANT! This is Bootstrap 5 version! WnModal is for older BS3
export default {
    props: {
        modalClass: {
            type: String,
            required: false,
        },
        backdrop: {
            type: [String, Boolean],
            default: true, // Set default to true, or 'static' for non-closing overlay
        },
        keyboard: {
            type: Boolean,
            default: true, // Set default to true to allow closing with ESC key
        },
    },
    data: () => ({
        instance: null,
    }),
    methods: {
        open() {
            this.instance.show()
        },
        close() {
            this.instance.hide()
        }
    },
    mounted() {
        if (typeof window.bootstrap === 'undefined') {
            return console.log('Bootstrap 5 JS not loaded')
        }

        const master = this.$refs.master
        const config = {
            backdrop: this.backdrop,
            keyboard: this.keyboard,
        }

        this.instance = new bootstrap.Modal(master, config)

        master.addEventListener('hidden.bs.modal', (evt) => {
            this.$emit('close');
        })

        master.addEventListener('shown.bs.modal', (evt) => {
            this.$emit('shown');
        })
    }
}
</script>
